"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./style.css");
var _data = _interopRequireDefault(require("./data"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 *
 * @returns
 */
var Region = function Region(props) {
  // 参数获取
  var setValueFn = props.setValueFn,
    level = props.level,
    provinceClassName = props.provinceClassName,
    cityClassName = props.cityClassName,
    areaClassName = props.areaClassName,
    _props$provinceId = props.provinceId,
    provinceId = _props$provinceId === void 0 ? 'select_province' : _props$provinceId,
    _props$cityId = props.cityId,
    cityId = _props$cityId === void 0 ? 'select_city' : _props$cityId,
    _props$areaId = props.areaId,
    areaId = _props$areaId === void 0 ? 'select_area' : _props$areaId;
  //存放省市区数据
  var _useState = (0, _react.useState)(_data.default),
    _useState2 = _slicedToArray(_useState, 2),
    regionList = _useState2[0],
    setRegionList = _useState2[1];
  //存放选中后的省市区：[省，市，区]
  var _useState3 = (0, _react.useState)(['', '', '']),
    _useState4 = _slicedToArray(_useState3, 2),
    callbackData = _useState4[0],
    setCallbackData = _useState4[1];
  //选中的省数据
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    provinceName = _useState6[0],
    setProvinceName = _useState6[1];
  //市数据
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    cityList = _useState8[0],
    setCityList = _useState8[1];
  //选中的市数据
  var _useState9 = (0, _react.useState)(''),
    _useState10 = _slicedToArray(_useState9, 2),
    cityName = _useState10[0],
    setCityName = _useState10[1];
  //区数据
  var _useState11 = (0, _react.useState)([]),
    _useState12 = _slicedToArray(_useState11, 2),
    areaList = _useState12[0],
    setAreaList = _useState12[1];
  //选中的区数据
  var _useState13 = (0, _react.useState)(''),
    _useState14 = _slicedToArray(_useState13, 2),
    areaName = _useState14[0],
    setAreaName = _useState14[1];
  // 加载组件时，只获取一次区服信息
  (0, _react.useEffect)(function () {
    setValueFn(callbackData);
  }, [callbackData]);
  //替换指定数组内容
  var updataRegionList = function updataRegionList(level, value) {
    switch (level) {
      case 'province':
        setAreaList([]); //每次选择省份时，清空已选择的区数据
        if (value >= 0) {
          setCityList(regionList[value].city); //当前省份的城市数据
          setCityName(regionList[value].city[0].name); //当前省份的第一个城市
          setCallbackData([regionList[value].name, '', '']); //当前选择的省份
        } else {
          //选择了“请选择省份”，清空已选中数据
          setCallbackData(['', '', '']);
          //回调数据
          setValueFn(setValueFn ? ['', '', ''] : null);
          //选择了“请选择省份”，清空城市、区数据
          setCityList([]);
        }
        break;
      case 'city':
        if (value >= 0) {
          setAreaList(cityList[value].area); //当前市的区数据
          setAreaName(cityList[value].area[0]); //当前市的第一个区
          setCallbackData([callbackData[0], cityList[value].name, '']); //当前省份的城市
        } else {
          //选择了“请选择市”，清空已选中数据
          setCallbackData([callbackData[0], '', '']);
          //回调数据
          setValueFn(setValueFn ? [callbackData[0], '', ''] : null);
          //选择了“请选择市”，清空区数据
          setAreaList([]);
        }
        break;
      case 'area':
        if (value >= 0) {
          setCallbackData([callbackData[0], callbackData[1], areaList[value]]); //当前城市的区
        } else {
          //选择了“请选择区”，清空已选中数据
          setCallbackData([callbackData[0], callbackData[1], '']);
          //回调数据
          setValueFn(setValueFn ? [callbackData[0], callbackData[1], ''] : null);
        }
        break;
      default:
        break;
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "Region"
  }, /*#__PURE__*/_react.default.createElement("select", {
    className: (0, _classnames.default)([!provinceClassName ? 'regionSelect' : '', provinceClassName ? provinceClassName : '']),
    id: provinceId,
    onChange: function onChange(e) {
      var value = e.target.value;
      //更新选中值
      setProvinceName(value);
      //更新省份的数组
      updataRegionList('province', Number(value));
    },
    value: provinceName
  }, regionList.map(function (ele, idx) {
    if (idx == 0) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: -1
      }, /*#__PURE__*/_react.default.createElement("option", {
        key: -1,
        value: -1
      }, "\u8BF7\u9009\u62E9\u7701\u4EFD"), /*#__PURE__*/_react.default.createElement("option", {
        key: idx,
        value: idx
      }, ele.name));
    } else {
      return /*#__PURE__*/_react.default.createElement("option", {
        key: idx,
        value: idx
      }, ele.name);
    }
  })), level == 'province' ? null : /*#__PURE__*/_react.default.createElement("select", {
    className: (0, _classnames.default)([!cityClassName ? 'regionSelect city' : '', cityClassName ? cityClassName : '']),
    id: cityId,
    onChange: function onChange(e) {
      var value = e.target.value;
      //更新选中值
      setCityName(value);
      //更新市的数组
      updataRegionList('city', Number(value));
    },
    value: cityName,
    disabled: cityList.length == 0
  }, cityList.length == 0 ? /*#__PURE__*/_react.default.createElement("option", {
    key: -1,
    value: -1
  }, "\u5148\u9009\u62E9\u7701\u4EFD") : null, cityList.map(function (ele, idx) {
    if (idx == 0) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: -1
      }, /*#__PURE__*/_react.default.createElement("option", {
        key: -1,
        value: -1
      }, "\u8BF7\u9009\u62E9\u5E02"), /*#__PURE__*/_react.default.createElement("option", {
        key: idx,
        value: idx
      }, ele.name));
    } else {
      return /*#__PURE__*/_react.default.createElement("option", {
        key: idx,
        value: idx
      }, ele.name);
    }
  })), level == 'province' || level == 'city' ? null : /*#__PURE__*/_react.default.createElement("select", {
    className: (0, _classnames.default)([!areaClassName ? 'regionSelect area' : '', areaClassName ? areaClassName : '']),
    id: areaId,
    onChange: function onChange(e) {
      var value = e.target.value;
      //更新选中值
      setAreaName(value);
      //更新区的数组
      updataRegionList('area', Number(value));
    },
    value: areaName,
    disabled: areaList.length == 0
  }, areaList.length == 0 ? /*#__PURE__*/_react.default.createElement("option", {
    key: -1,
    value: -1
  }, "\u5148\u9009\u62E9\u5E02") : null, areaList.map(function (ele, idx) {
    if (idx == 0) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: -1
      }, /*#__PURE__*/_react.default.createElement("option", {
        key: -1,
        value: -1
      }, "\u8BF7\u9009\u62E9\u533A"), /*#__PURE__*/_react.default.createElement("option", {
        key: idx,
        value: idx
      }, ele));
    } else {
      return /*#__PURE__*/_react.default.createElement("option", {
        key: idx,
        value: idx
      }, ele);
    }
  })));
};
var _default = Region;
exports.default = _default;